// Types
import type { MasterType } from "../../types"

export const defaultMasterData: MasterType = {
  category: [],
  colour: [],
  group: [],
  material: [],
  product: [],
  product_category: [],
  size: [],
  style: [],
  unit: []
}